// modal-template.js
import axios from 'axios';
import Notification from '../notification/notification-es';
import {modalTemplateLogin} from "./modal-template-login/modal-template-login";
import {
    modalTemplateCreateStudentGroup
} from "./modal-template-create-student-group/modal-template-create-student-group";
import {modalTemplateCreateStudentTask} from "./modal-template-create-student-task/modal-template-create-student-task";
import {
    modalTemplateCopyReferal
} from "./modal-template-copy-referal/modal-template-copy-referal";
import {modalTemplateRegister} from "./modal-template-register/modal-template-register";
import {modalTemplateRegisterFinal} from "./modal-template-register-final/modal-template-register-final";
import {modalTemplatePasswordReset} from "./modal-template-password-reset/modal-template-password-reset";


const classPrefix = 'modal-template';
const dataPrefix = 'data-modal-template';

const popup = Notification({
    position: 'top-right',
    duration: 3000,
    isHidePrev: false,
    isHideTitle: true,
    maxOpened: 3,
});

const $modal = document.querySelector(`[${dataPrefix}]`);
export const modal = $modal ? modalTemplate() : null;

function modalTemplate() {
    console.log("----------MODAL TEMPLATE INIT")
    const $container = $modal.querySelector(`.${classPrefix}__container`);
    const $content = $modal.querySelector(`[${dataPrefix}-modal-content]`);
    const $closeBtn = $modal.querySelector(`[${dataPrefix}-modal-close]`);

    // --- helpers ---
    function lockBodyScroll() {
        document.body.classList.add(`${classPrefix}--open-body`); // можно стилизовать .modal-template--open-body { overflow: hidden; }
    }
    function unlockBodyScroll() {
        document.body.classList.remove(`${classPrefix}--open-body`);
    }

    function openModal() {
        $modal.classList.add(`${classPrefix}--open`);
        $modal.setAttribute('aria-hidden', 'false');
        lockBodyScroll();
        document.addEventListener('keydown', onKeyDown);
    }

    function closeModal() {
        $modal.classList.remove(`${classPrefix}--open`);
        $modal.setAttribute('aria-hidden', 'true');
        clearContent();
        unlockBodyScroll();
        document.removeEventListener('keydown', onKeyDown);
    }

    function clearContent() {
        if ($content) $content.innerHTML = ''; // очистка
    }

    function onKeyDown(e) {
        if (e.key === 'Escape') {
            closeModal();
        }
    }

    // Рендерщик шаблонов. Добавляйте кейсы для новых шаблонов.
    // Для сложных компонентов можно вызывать здесь реальный рендер/инициализацию.
    async function renderTemplate(templateName, params = {}) {

        console.log(templateName)
        console.log(params)

        if (!$content) return;
        clearContent();

        switch (templateName) {
            case 'login':
                modalTemplateLogin($content, params);
                break;
            case 'register':
                modalTemplateRegister($content, params);
                break;
            case 'register-final':
                modalTemplateRegisterFinal($content, params);
                break;
            case 'create-student-group':
                modalTemplateCreateStudentGroup($content, params);
                break;
            case 'create-student-task':
                modalTemplateCreateStudentTask($content, params);
                break;
            case 'restore-password':
                modalTemplatePasswordReset($content, params);
                break;
            case 'copy-referal':
                // передаём params в шаблон — в том числе callback params.onCopy или данные реферала
                modalTemplateCopyReferal($content, params);
                break;
            default:
                $content.innerHTML = `<div><strong>Шаблон:</strong> ${templateName}</div>`;
                break;
        }
    }

    // --- события открытия ---
    function initModalOpen() {
        document.addEventListener('click', async (event) => {
            const button = event.target.closest('[data-modal-open-template]');
            if (!button || !$modal) return;

            const templateName = button.getAttribute('data-modal-open-template');
            if (!templateName) return;

            // собираем все data-* атрибуты кнопки в объект (button.dataset)
            // пример: data-modal-referral -> dataset.modalReferral
            const params = { ...(button.dataset || {}) };

            openModal();
            await renderTemplate(templateName, params);
        });
    }

    // --- события закрытия ---
    function initModalClose() {
        // клик по кнопке закрытия
        if ($closeBtn) {
            $closeBtn.addEventListener('click', () => {
                closeModal();
            });
        }

        // логика для корректного определения "где начался клик"
        let pointerStartedInside = false;

        function handlePointerDown(e) {
            const path = e.composedPath ? e.composedPath() : null;
            pointerStartedInside = path ? path.includes($container) : $container.contains(e.target);
        }

        // используем Pointer events, если доступны; иначе fallback на mouse/touch
        if (window.PointerEvent) {
            $modal.addEventListener('pointerdown', handlePointerDown);
        } else {
            $modal.addEventListener('mousedown', handlePointerDown);
            $modal.addEventListener('touchstart', handlePointerDown);
        }

        // клик по overlay — закрываем только если клик был вне контейнера
        $modal.addEventListener('click', (e) => {
            const path = e.composedPath ? e.composedPath() : null;
            const clickOutside = path ? !path.includes($container) : !$container.contains(e.target);

            // Закрываем только если клик был вне и начало клика тоже было вне
            if (clickOutside && !pointerStartedInside) {
                closeModal();
            }

            // Сбрасываем флаг на следующий взаимодействие
            pointerStartedInside = false;
        });
    }


    // init
    initModalOpen();
    initModalClose();

    document.addEventListener('modal-template:notify', (e) => {
        const text = e?.detail?.text || '';
        try {
            popup.success({ message: text });
        } catch (err) {
            console.log('notice (fallback):', text);
        }
    });
    document.addEventListener('modal-template:close', () => {
        closeModal();
    });

    return {
        open: (name, dataset) => {
            renderTemplate(name, dataset).then(openModal);
        },
        close: closeModal,
        render: renderTemplate,
    };
}
